module.exports = __webpack_public_path__ + "img/asset4.6669cbe7.png";